import { createContext, PropsWithChildren } from 'react';
import { INewAuthContext } from '@/providers/AuthProvider/NewAuthProvider.types';
import { useAuthManager } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import Loader from '@/components/Loader/Loader';

export const NewAuthContext = createContext<Partial<INewAuthContext>>({});

export const NewAuthProvider = ({ children }: PropsWithChildren) => {
  const authUser = useAuthManager();

  if (authUser.token === undefined) return <Loader />;

  return <NewAuthContext.Provider value={authUser}>{children}</NewAuthContext.Provider>;
};
